// Shared key builder for Formik field names in Questionnaire Preview/Edit.
//
// - Unanswered questionnaires: Item ids are unique => key = `q:<id>`
// - Answered questionnaires: repeatables produce multiple rows => key = `d:<DetailId>`
//
// IMPORTANT: keep this in sync with any place that reads/writes formik.values.

export default function questionnaireFieldKey(item) {
	// UI-only identity (uuid strategy)
	if (item?.uiId) {
		return `u:${String(item.uiId)}`;
	}

	if (!item) return "";

	// Answered questionnaires (preview-by-header): backend unique row id
	if (item.DetailId != null) return `d:${String(item.DetailId)}`;

	// IMPORTANT:
	// For questions/attributes we key by backend ItemId (q:...) so validation + submit aggregate correctly.
	// Using r:<_runtimeId> here breaks validation because Yup/schema produce errors under q:<ItemId>.
	const type = String(item?.Type ?? "");
	const isQuestionLike = type === "question" || type === "attribute";
	if (!isQuestionLike) {
		// Unanswered UI-only instances (typically groups/clones)
		if (item._runtimeId) return `r:${String(item._runtimeId)}`;
	}

	// Unanswered base (stable backend id)
	// Prefer backend ItemId when available; `id` can be overwritten for UI-tree purposes.
	const baseId = item?.ItemId ?? item?.id;
	if (baseId != null) return `q:${String(baseId)}`;

	return "";
}